import { Observable, of } from 'rxjs'
import { CanActivate, CanLoad, Route } from '@angular/router'
import { Injectable } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { catchError, map, switchMapTo, take, tap } from 'rxjs/operators'
import * as fromRoot from '@tv3/store/state'
import { selectUserPreferencesLoaded } from '@tv3/store/user-preferences/user-preferences.selectors'
import { LoadUserPreferences } from '@tv3/store/user-preferences/user-preferences.actions'
import { IsDataLoaded } from '@tokeet-frontend/tv3-platform'

@Injectable({ providedIn: 'root' })
export class UserPreferencesGuard implements CanActivate, CanLoad, IsDataLoaded {
  constructor(private store: Store<fromRoot.State>) {}

  public canActivate(): Observable<boolean> {
    return this.isDataLoaded().pipe(
      switchMapTo(of(true)),
      catchError(() => of(false))
    )
  }

  isDataLoaded(): Observable<boolean> {
    return this.store.pipe(
      select(selectUserPreferencesLoaded),
      tap((isLoaded) => {
        if (!isLoaded) {
          this.store.dispatch(LoadUserPreferences())
        }
      }),
      map(() => true),
      take(1)
    )
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate()
  }
}
